import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { appId, db } from '@/lib/firebase';

export type GivingInterest = 'gold' | 'silver' | 'bronze' | 'unsure';

export type CompanySize = '1-50' | '51-200' | '201-1000' | '1000+';

export type CorporateInquiryAdminStatus = 'new' | 'in_review' | 'contacted' | 'closed';

export interface CorporateInquiryInput {
  companyName: string;
  contactName: string;
  email: string;
  phone?: string | null;
  companySize: CompanySize;
  givingInterest: GivingInterest;
  message?: string | null;
  selectedTier?: string | null;
  selectedAmount?: number | null;
  source: string;
}

export async function submitCorporateInquiry(input: CorporateInquiryInput): Promise<void> {
  const collRef = collection(db, 'artifacts', appId, 'public', 'data', 'corporateInquiries');
  await addDoc(collRef, {
    companyName: input.companyName.trim(),
    contactName: input.contactName.trim(),
    email: input.email.trim().toLowerCase(),
    phone: input.phone?.trim() || null,
    companySize: input.companySize,
    givingInterest: input.givingInterest,
    message: input.message?.trim() || null,
    selectedTier: input.selectedTier?.trim() || null,
    selectedAmount:
      input.selectedAmount != null && Number.isFinite(input.selectedAmount)
        ? input.selectedAmount
        : null,
    source: input.source,
    adminStatus: 'new' as CorporateInquiryAdminStatus,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}
